/**
 *
 * @param {IconProps} props
 * @returns {React.JSX.Element}
 */
const Addition = ({svg_props, path_props}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    {...svg_props}
  >
    <path
      d="M8 1v14M1 8h14"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...path_props}
    />
  </svg>
);
export default Addition;
